import { CardProfileDtoToEntity } from "src/app/features/ApplicationProfile/subFeatures/CardProfile/services/mappers/CardProfileDtoToEntity";
import { CardProfileEntityToDto } from "src/app/features/ApplicationProfile/subFeatures/CardProfile/services/mappers/CardProfileEntityToDto";
import type {
    CardProfileQueryParams,
    CardProfilesEntityObject,
} from "src/app/features/ApplicationProfile/subFeatures/CardProfile/services/server/types";
import type { CardProfileEntity } from "src/app/features/ApplicationProfile/subFeatures/CardProfile/types/CardProfileEntity";
import { getAssignedDataGroup } from "../../../../../../../core/router/auth";
import { ResourceName } from "../../../../../../../core/router/config/ResourceName";
import { baseAuthApi } from "../../../../../../../core/service/baseApi";
import type { Dto } from "../../../../../../../core/types/be/Dto";

export const CardProfileApi = baseAuthApi.injectEndpoints({
    endpoints: (builder) => ({
        CardProfileLoad: builder.query<CardProfileEntity, CardProfileQueryParams>({
            providesTags: [ResourceName.APPLICATION_PROFILE_LISTS],
            query: (cardProfileQueryParams) => {
                const dataGroup = getAssignedDataGroup();
                return {
                    url: `${ResourceName.DATA_GROUPS}/${dataGroup?.code}/${ResourceName.APPLICATION_PROFILE_LISTS}/${cardProfileQueryParams.appProfileId}/${ResourceName.APPLICATION_PROFILE_CARD_DEFINITION}/${cardProfileQueryParams.id}`,
                    method: "GET",
                };
            },
            transformResponse: (response: Dto, _) => {
                return CardProfileDtoToEntity(response);
            },
        }),
        CardProfileSave: builder.mutation<CardProfileEntity, CardProfilesEntityObject>({
            query: (cardProfilesEntityObject) => {
                const dataGroup = getAssignedDataGroup();

                const url = `${ResourceName.DATA_GROUPS}/${dataGroup?.code}/${ResourceName.APPLICATION_PROFILE_LISTS}/${cardProfilesEntityObject.cardProfileQuery.appProfileId}/${ResourceName.APPLICATION_PROFILE_CARD_DEFINITION}`;
                const method = "POST";

                const body = CardProfileEntityToDto(cardProfilesEntityObject.cardProfilesFormData);

                return {
                    url,
                    method,
                    body,
                };
            },
            invalidatesTags: [ResourceName.APPLICATION_PROFILE_LISTS],
        }),
        CardProfileUpdate: builder.mutation<CardProfileEntity, CardProfilesEntityObject>({
            query: (cardProfilesEntityObject) => {
                const dataGroup = getAssignedDataGroup();

                const url = `${ResourceName.DATA_GROUPS}/${dataGroup?.code}/${ResourceName.APPLICATION_PROFILE_LISTS}/${cardProfilesEntityObject.cardProfileQuery.appProfileId}/${ResourceName.APPLICATION_PROFILE_CARD_DEFINITION}/${cardProfilesEntityObject.cardProfileQuery.id}`;
                const method = "PUT";

                const body = CardProfileEntityToDto(cardProfilesEntityObject.cardProfilesFormData);

                return {
                    url,
                    method,
                    body,
                };
            },
            invalidatesTags: [ResourceName.APPLICATION_PROFILE_LISTS],
        }),
    }),
});

export const { useLazyCardProfileLoadQuery, useCardProfileSaveMutation, useCardProfileUpdateMutation } = CardProfileApi;
